var _rect, _line, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiceBackgroundD8(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 103 103",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -3.17157,
    y: 51.5,
    width: 77.3172,
    height: 77.3172,
    rx: 14,
    transform: "rotate(-45 -3.17157 51.5)",
    fill: "#EAF0FF",
    stroke: "#363636",
    strokeWidth: 4
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 51,
    x2: 99,
    y2: 51,
    stroke: "#363636",
    strokeWidth: 4
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 45,
    y: 37,
    fill: "#363636",
    fontSize: "20px",
    fontWeight: 600
  }, "8")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiceBackgroundD8);
export default __webpack_public_path__ + "static/media/DiceBackground_D8.0ec6feb25235912e3774afad75d12670.svg";
export { ForwardRef as ReactComponent };